import glyphs from './glyphs.json';
import { P } from './palette';
const GLYPHS: Record<string,string[]> = glyphs;
export function text(ctx: CanvasRenderingContext2D, value: string, x: number, y: number, color: string=P.white, scale=1): void {
  ctx.fillStyle=color;
  for (const [i,char] of [...value.toUpperCase()].entries()) {
    const glyph=GLYPHS[char]||GLYPHS[' '];
    glyph?.forEach((row,gy)=>[...row].forEach((p,gx)=>{if(p==='1')ctx.fillRect(Math.round(x+i*6*scale+gx*scale),Math.round(y+gy*scale),scale,scale);}));
  }
}
export const textWidth = (value:string,scale=1): number => (value.length*6-1)*scale;
export function centered(ctx:CanvasRenderingContext2D,value:string,y:number,color:string=P.white,scale=1):void {
  text(ctx,value,(224-textWidth(value,scale))/2,y,color,scale);
}
